<template>
  <el-tooltip content="Calendar" placement="bottom">
    <el-button circle style="width: 35px; height: 35px" @click="navigateCalendar">
      <fa-icon :icon="faCalendarDays" class="text-[16px]" />
    </el-button>
  </el-tooltip>
</template>
<script>
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons'
import { useRouter } from 'vue-router'

export default {
  name: 'Calendar',
  setup() {
    const router = useRouter()
    const navigateCalendar = () => {
      router.push({ name: `advisor/calendar` })
    }
    return {
      faCalendarDays,
      navigateCalendar,
    }
  },
}
</script>
